export const APP_CONFIG = {
  name: 'Platform',
  version: '1.0.0',
  defaultLocale: 'es-AR',
  defaultCurrency: 'ARS',
  pagination: {
    defaultPageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
  },
  session: {
    tokenKey: 'hb_auth_token',
    refreshTokenKey: 'hb_refresh_token',
    expirationKey: 'hb_token_expiration',
  },
  validation: {
    password: {
      minLength: 8,
      requireUppercase: true,
      requireLowercase: true,
      requireNumber: true,
      requireSpecialChar: true,
    },
  },
} as const;
